import { injectable } from 'inversify';
import * as Api from "@/app/interaction/api";
import { Vue } from 'vue-property-decorator'
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import { createInteractionComponent } from '@/app/interaction/ui'
import { EmbedContent, EmbedState, EmbedItem } from './embed-interfaces';

@injectable()
export class IncludeEmbedHandler implements Api.IncludeComponentsHandlerInterface {

  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.embed.component', $parsedContent)
    if (elements === null) {
      return []
    }
    
    let components = []
    for (const element of elements) {
      const $element: any = $(element)
      const component = this.includeComponent($element)
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id')
    const title: string|null =  $('.embed__title', $element).text() || null;
    const instruction: string|null = $('.embed__instruction', $element).text() || null;
    const $itemsContainer: any = $('.embed__items', $element);
    const item: EmbedItem = this.getItem($('.embed__item', $itemsContainer));
 
    const interactionComponent = createInteractionComponent<EmbedContent, EmbedState>(id, 'embed', {
      title, 
      instruction
    }, {
      item
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItem($item: any): EmbedItem {
    let item: EmbedItem
      item = {
          uri:    $item.attr('data-uri') as string,
          size:   $item.attr('data-size') as string,
          aspect: $item.attr('data-aspect') as string,
        }

    return item;
  }
}
